<script>
  import { getContext } from "svelte";
  import { Delaunay } from "d3-delaunay";

  const { xGet, yScale, width, height } = getContext("LayerCake");

  let {
    points = [],
    activeIndex = $bindable(null),
    activePoint = $bindable(null),
  } = $props();

  function yGet(d) {
    return $yScale(d.value);
  }

  let pointsXY = $derived(
    points
      .filter((d) => d.value != null)
      .map((d) => {
        const point = [$xGet(d), yGet(d)];
        point.data = d;
        return point;
      })
  );

  let voronoiWidth = $derived(Math.max($width, 1));
  let voronoiHeight = $derived(Math.max($height, 1));

  let voronoi = $derived(
    Delaunay.from(pointsXY).voronoi([0, 0, voronoiWidth, voronoiHeight])
  );
</script>

{#each pointsXY as point, i}
  <path
    class="voronoi-cell"
    d={voronoi.renderCell(i)}
    onmousemove={(e) => {
      activeIndex = i;
      activePoint = { x: pointsXY[i][0], y: pointsXY[i][1], pageX: e.pageX, pageY: e.pageY, ...pointsXY[i].data };
    }}
    onmouseleave={() => {
      activeIndex = null;
      activePoint = null;
    }}
    role="tooltip"
  ></path>
{/each}

<style>
  .voronoi-cell {
    fill: none;
    stroke: none;
    pointer-events: all;
    outline: none;
  }
</style>
